// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"76b7e77f56f52ba1","5405":"ebc41cfdb43690a6","6620":"ebc41cfdb43690a6"}[chunkId] + ".css";
};